import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import PaymentMethod, { type PaymentMethodProps } from "./PaymentMethod";

interface PaymentMethodModalProps extends Omit<PaymentMethodProps, "onBack"> {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export default function PaymentMethodModal({
  subscriptionId,
  isOpen,
  setIsOpen,
  paymentSource,
}: PaymentMethodModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content className="lg:w-[448px]">
        <PaymentMethod
          subscriptionId={subscriptionId}
          paymentSource={paymentSource}
          onBack={() => setIsOpen(false)}
        />
      </Content>
    </Component>
  );
}
